

class HostovaniDlouhodobaUtils {
    public static Stav_PotvrzeniICaDomKC = 0;   // 0 - ceka se na potvrzeni IC a domaciho KČ
    public static Stav_ZaplaceniPopl = 1;        // 1 - ceka se na zaplaceni popl. za hostovani 
    public static Stav_Zpracovani = 11;          // 11 - ceka se na zapracovani hostovani sekretariatem
    public static Stav_Vyrizeno = 1001;          // 1001 - hostovani vyrizeno
    public static Stav_Ukonceno = 1002;          // 1002 - hostovani ukonceno
    public static Stav_Zamitnuto = 1801;         // 1801 - hostovani zamitnuto indiv. clenem nebo hostujicim KC
    public static Stav_Stornovan = 1901;         // 1901 - hostovani stornovano

    public static TypZpravy_Porizeni = 1;
    public static TypZpravy_PotvrzeniIC = 2; // IC - pokud je zadano i potvrz. Host KC, pridaji se informace pro platbu
    public static TypZpravy_PotvrzeniKC = 3; // Domaci KC - pokud je zadano i potvrz IC, pridaji se informace pro platbu
    public static TypZpravy_ZaplaceniSP = 4;
    public static TypZpravy_Provedeni = 5;
    public static TypZpravy_Ukonceni = 6; // zruseni stavajiciho hostovani, pokud je nove hostovani
    public static TypZpravy_Storno = 7; // storno nedokonceneho hostovani    
}

export default HostovaniDlouhodobaUtils;